module.exports = __webpack_public_path__ + "img/2_E.d811c302.webp";